import { graphql } from '@/generated/gql';

export const NEGOTIATION_DEMAND_RESET_MUTATION = graphql(/* GraphQL */ `
  mutation DemandReset($id: UUID!) {
    tesseract {
      demand(id: $id) {
        reset {
          id
          status
          awardingConfiguration {
            id
            deadline
          }
        }
      }
    }
  }
`);
